'use strict';
var $67d356ae72155e88$exports = {};
'use strict';
var $43d2ed0487f6b72e$exports = {};
var $43d2ed0487f6b72e$var$n = {
    /**
     * method
     * @param {Number} max Max value of the range.
     * @param {Number} min Min value of the range.
     * @parma {Number} step Step value of the range.
     * @return {Array<Number>} Number Array of range stepped by step.
     */ range: function(max, min = 1, step = 1) {
        if (max == 0) return [];
        if (max == min) return [
            max
        ];
        if (max < min) throw new Error(`max must be larger than min. max = ${max}, min = ${min}`);
        let range = [];
        for(let i = min; i <= max; i += step)range.push(i);
        return range;
    },
    array_shuffle: function(input_array) {
        let result = input_array.sort(()=>Math.random() - 0.5);
        return result;
    }
};
$43d2ed0487f6b72e$exports = $43d2ed0487f6b72e$var$n;


const $67d356ae72155e88$var$CODE = {
    ALPHA: {
        start: 97,
        end: 122
    },
    CAP: {
        start: 65,
        end: 90
    },
    NUM: {
        start: 48,
        end: 57
    }
};
class $67d356ae72155e88$var$Password {
    constructor(min = 12, max = 16, cap = 1, sign = 1, num = 1){
        this.min = min;
        this.max = max;
        this.cap = cap;
        this.sign = sign;
        this.num = num;
        this.length = min;
        this.allowed_signs = [];
    }
    gen() {
        if (this.min > this.max) this.max = this.min;
        if (this.min == this.max) this.length = this.min;
        else this.length = Math.floor(Math.random() * (this.max + 1 - this.min)) + this.min;
        const alpha_length = this.length - (this.cap + this.sign + this.num);
        try {
            const alpha_letters = this.createLetters(alpha_length, ()=>this.alphaChar());
            const cap_letters = this.createLetters(this.cap, ()=>this.capChar());
            const sign_letters = this.createLetters(this.sign, ()=>this.signChar());
            const num_letters = this.createLetters(this.num, ()=>this.numChar());
            const cat = alpha_letters.concat(cap_letters, sign_letters, num_letters);
            const shuffled = $43d2ed0487f6b72e$exports.array_shuffle(cat);
            // Insert random symbols or numbers between words
            // TODO: UI が無い。テストが無い。文字数が変わってしまう。
            const withSeparators = this.insertSeparators(shuffled);
            return {
                length: this.length,
                text: shuffled.join(''),
                success: true
            };
        } catch (e) {
            console.error(e);
            return {
                length: -1,
                text: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u751F\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u6700\u5C0F\u6587\u5B57\u6570\u304B\u6700\u5927\u6587\u5B57\u6570\u304C\u5C0F\u3055\u3059\u304E\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002",
                success: false
            };
        }
    }
    insertSeparators(array) {
        // Use dedicated separator characters that don't depend on allowed_signs
        const defaultSeparators = [
            '-',
            '_',
            '!',
            '@',
            '#',
            '$',
            '%',
            '^',
            '&',
            '*'
        ];
        const separators = defaultSeparators;
        const result = [];
        for(let i = 0; i < array.length; i++){
            result.push(array[i]);
            if (i < array.length - 1) {
                const randomSeparator = separators[Math.floor(Math.random() * separators.length)];
                result.push(randomSeparator);
            }
        }
        return result;
    }
    createLetters(length, func) {
        return $43d2ed0487f6b72e$exports.range(length).map(()=>func());
    }
    randomIndex(type) {
        return Math.floor(Math.random() * (type.end + 1 - type.start)) + type.start;
    }
    alphaChar() {
        return String.fromCharCode(this.randomIndex($67d356ae72155e88$var$CODE.ALPHA));
    }
    capChar() {
        return String.fromCharCode(this.randomIndex($67d356ae72155e88$var$CODE.CAP));
    }
    setAllowedSigns(allowed) {
        this.allowed_signs = allowed.split('');
    }
    signChar() {
        let signs = [];
        if (this.allowed_signs.length !== 0) signs = this.allowed_signs;
        else {
            const parts = [
                {
                    start: 33,
                    end: 47
                },
                {
                    start: 58,
                    end: 64
                },
                {
                    start: 91,
                    end: 96
                },
                {
                    start: 123,
                    end: 126
                }
            ];
            parts.forEach((e)=>{
                for(let i = e.start; i <= e.end; i++)signs.push(String.fromCharCode(i));
            });
        }
        let picked = signs[this.randomIndex({
            start: 0,
            end: signs.length - 1
        })];
        return picked;
    }
    escapeStr(input_str) {
        const escape_list = {
            "<": "&lt;",
            ">": "&gt;"
        };
        const escaped_str = input_str.split('').map((c)=>{
            if (c in escape_list) return escape_list[c];
            return c;
        });
        return escaped_str.join('');
    }
    numChar() {
        return String.fromCharCode(this.randomIndex($67d356ae72155e88$var$CODE.NUM));
    }
}
$67d356ae72155e88$exports = $67d356ae72155e88$var$Password;


let $77ac944da51b7354$var$p = new $67d356ae72155e88$exports();
let $77ac944da51b7354$var$form_valid = true;
const $77ac944da51b7354$var$generate_button = document.getElementById('generate-button');
$77ac944da51b7354$var$generate_button.addEventListener('click', ()=>{
    if (!$77ac944da51b7354$var$form_valid) return;
    const new_password = document.createElement('li');
    let result = $77ac944da51b7354$var$p.gen();
    if (result.success) {
        new_password.className = "password";
        new_password.addEventListener('click', $77ac944da51b7354$var$password_click);
        new_password.innerHTML = $77ac944da51b7354$var$p.escapeStr(result.text);
    } else new_password.innerHTML = `<span style="color:red">${$77ac944da51b7354$var$p.escapeStr(result.text)}</span>`;
    document.querySelector('#generated-list').appendChild(new_password);
});
function $77ac944da51b7354$var$password_click(e) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(e.target);
    selection.removeAllRanges();
    selection.addRange(range);
    const result = document.execCommand('copy');
    let text = '';
    if (result) text = "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002";
    else text = "\u30B3\u30D4\u30FC\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002";
    $77ac944da51b7354$var$show_toast(text);
    selection.removeAllRanges();
}
var $77ac944da51b7354$var$showing_toast = false;
function $77ac944da51b7354$var$show_toast(text) {
    let toast = document.getElementById('toast');
    toast.innerText = text;
    if ($77ac944da51b7354$var$showing_toast) return;
    $77ac944da51b7354$var$showing_toast = true;
    toast.classList.remove('fadeout');
    toast.classList.add('fadein');
    toast.style.opacity = '1.0';
    setTimeout(()=>$77ac944da51b7354$var$hide_toast(), 2000);
}
function $77ac944da51b7354$var$hide_toast() {
    let toast = document.getElementById('toast');
    toast.classList.remove('fadein');
    toast.classList.add('fadeout');
    toast.style.opacity = '0.0';
    $77ac944da51b7354$var$showing_toast = false;
}
const $77ac944da51b7354$var$erase_button = document.getElementById('erase-button');
$77ac944da51b7354$var$erase_button.addEventListener('click', ()=>{
    document.querySelector('#generated-list').innerHTML = '';
});
[
    "min",
    "max",
    "cap",
    "sign",
    "num"
].forEach((e)=>{
    const length = document.getElementById(e + '-length');
    length.addEventListener('change', (elm)=>{
        $77ac944da51b7354$var$p[e] = +elm.target.value;
    });
});
const $77ac944da51b7354$var$allowed_signs = document.getElementById('allowed-signs');
$77ac944da51b7354$var$allowed_signs.addEventListener('keyup', (e)=>{
    if (e.target.value.length === 0 || $77ac944da51b7354$var$validate_signs(e.target.value)) {
        $77ac944da51b7354$var$p.setAllowedSigns(e.target.value);
        $77ac944da51b7354$var$form_valid = true;
        $77ac944da51b7354$var$allowed_signs_error(false);
    } else {
        $77ac944da51b7354$var$show_toast("\u8A18\u53F7\u3060\u3051\u3092\u5165\u529B\u3057\u3066\u4E0B\u3055\u3044");
        $77ac944da51b7354$var$form_valid = false;
        $77ac944da51b7354$var$allowed_signs_error(true);
    }
});
function $77ac944da51b7354$var$validate_signs(value) {
    return value.match(/[^!"#$%&'()*+,\-./:;<=>?@\[\\\]\^_`\{\|\}~]/) === null;
}
function $77ac944da51b7354$var$allowed_signs_error(error) {
    let allowed_signs_input = document.getElementById('allowed-signs');
    let allowed_signs_label = document.querySelector('label[for="allowed-signs"]');
    if (error) {
        allowed_signs_input.classList.add('error');
        allowed_signs_label.classList.add('error-label');
    } else {
        allowed_signs_input.classList.remove('error');
        allowed_signs_label.classList.remove('error-label');
    }
}


//# sourceMappingURL=js-password.f0b10965.js.map
